import React from "react"
import { getSvgFill } from "utils"

const NotSure = ({ isSelected }: { isSelected: boolean }) => {
  const { backgroundFill, pathFill } = getSvgFill(isSelected)

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
    >
      <path
        d="M7.53685 6.4612C7.22848 6.39351 6.85995 6.31078 6.83738 5.94976C6.76217 4.76141 6.90507 3.731 7.22096 2.85102C4.43812 4.16723 1.06862 6.27317 0.888111 9.13875C0.805377 10.4174 1.3469 11.6508 2.49765 12.8241C3.70856 14.0501 5.58134 15.2159 8.10846 16.314C8.28145 16.3892 8.37923 16.5547 8.37923 16.7276V22H17.5476V15.9454C17.5476 15.6972 17.7506 15.4942 17.9988 15.4942C18.247 15.4942 18.4501 15.6972 18.4501 15.9454V22H21.1201L21.1126 15.261C21.1126 12.6963 19.1947 11.3425 16.8105 10.8987C14.8625 13.4108 11.4404 13.5838 9.29682 11.2372C8.11599 11.5079 6.37859 11.696 5.28801 11.1243C4.58854 10.7633 4.24257 10.1391 4.29521 9.34934C4.38547 8.13843 6.30338 7.08546 7.53685 6.4612ZM9.89099 5.9648C9.50741 6.22052 9.09374 6.40855 8.65751 6.48376C8.52213 8.01057 8.99597 9.49224 9.91355 10.5452C11.5833 12.4631 14.2683 12.4631 15.938 10.5452C16.6902 9.68027 17.1715 8.49945 17.2166 7.19076C15.1558 7.27349 12.6964 6.42359 11.4178 4.49065C10.959 5.06226 10.4551 5.58874 9.89099 5.9648ZM7.71736 5.58122C9.14639 5.90463 10.3272 4.48312 11.1019 3.40759C11.305 3.12931 11.7262 3.17444 11.8691 3.47528C12.8393 5.48344 15.1784 6.34086 17.0963 6.28821C17.3821 6.28069 17.8635 6.24309 18.1041 6.12275C18.247 3.3399 16.9534 1.48969 15.2461 0.609706C13.7268 -0.172499 11.839 -0.217627 10.3197 0.564578C8.77785 1.36183 7.64215 3.02401 7.71736 5.58122Z"
        fill={pathFill}
        fillOpacity={isSelected ? 1 : 0.6}
      />
    </svg>
  )
}

export default NotSure
